export const ISSUER = '${ENV_REACT_APP_ISSUER}';
export const CLIENT_ID = '${ENV_REACT_APP_CLIENT_ID}';
export const PORT = '${ENV_REACT_APP_PORT}';
export const PKCE = '${ENV_REACT_APP_PKCE}';
export const LocalEnv = '${ENV_REACT_APP_LocalEnv}';
export const AuthorizeUrl = '${ENV_REACT_APP_AuthorizeUrl}';
export const REDIRECT_URI = '${ENV_REACT_APP_REDIRECT_URI}';
export const LOGOUT_URI = '${ENV_REACT_APP_LOGOUT_URI}';
export const CAF_URI = '${ENV_REACT_APP_CAF_URI}';
export const FULLSTORY_ORG = '${ENV_REACT_APP_FULLSTORY_ORG}';
export const FULLSTORY_NAMESPACE = '${ENV_REACT_APP_FULLSTORY_NAMESPACE}';
export const APPD_PSD_KEY = '${ENV_REACT_APP_APPD_PSD_KEY}';
export const GROWTHBOOK_HOST_URL = '${ENV_REACT_APP_GROWTHBOOK_HOST_URL}';
export const GROWTHBOOK_CLIENTKEY = '${ENV_REACT_APP_GROWTHBOOK_CLIENTKEY}';
export const WIDGET_SERVICE_URI = '${ENV_REACT_APP_WIDGET_SERVICE_URI}';
export const REMOTE_ENTRY_URI = '${ENV_REACT_APP_REMOTE_ENTRY_URI}';
export const MSAL_URI = '${ENV_REACT_APP_MSAL_URI}';
export const DATOCMS_API_URL = '${ENV_REACT_APP_DATOCMS_API_URL}';
export const DATOCMS_API_TOKEN = '${ENV_REACT_APP_DATOCMS_API_TOKEN}';
export const DATOCMS_ENVIRONMENT = '${ENV_REACT_APP_DATOCMS_ENVIRONMENT}';
export const CMS_ENABLED = '${ENV_REACT_APP_CMS_ENABLED}';
